import { ReactNode } from "react";
import { ServicesProvider } from "./Services";
import { UserProvider } from "./User";
import { HabUnitProvider } from "./HabUnit";
import { ProductsProvider } from "./Products";
import { GuestsProvider } from "./Guests"

interface ProvidersProps {
  children: ReactNode;
}

const Providers = ({ children }: ProvidersProps) => {
  return (
      <UserProvider>
        <ProductsProvider>
          <HabUnitProvider>
            <ServicesProvider>
              <GuestsProvider>
                {children}
              </GuestsProvider>
            </ServicesProvider>
          </HabUnitProvider>
        </ProductsProvider>
      </UserProvider>
  );
};

export default Providers;
